import { render } from "./CadastrarHabilitacaoManual.vue?vue&type=template&id=63b644b6"
import script from "./CadastrarHabilitacaoManual.vue?vue&type=script&lang=js"
export * from "./CadastrarHabilitacaoManual.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__